import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import "../Modal.css";
import "./GuideDownload.css";
import MultiSelectModal from "../MultiSelectModal";
import AlertModal from "../AlertModal";
import GuideCard from "./GuideCard";
import SharedInvitations from "./SharedInvitations";
import { notifySharingChanged, getSharingState, onSharingChanged } from "../../../Common/useInvitationCount";
import { splitSharedGuides, applySharingAction, hiddenFromLibrary } from "../../../Common/shareInvites";
import DataBase from "../../../dataBase/liquidGuides";
import Guide from "../../../Models/Guide";
import User from "../../../Models/User";
import { AI_DISCLAIMER, AI_DISCLAIMER_LINK_TEXT, FEEDBACK_URL } from "../../../Common/aiDisclaimer";

const GdDialogWrapper = React.forwardRef(
  ({ className, contentClassName, children, centered, scrollable, size, fullscreen, ...rest }, ref) => (
    <div
      ref={ref}
      {...rest}
      className={['modal-dialog', className].filter(Boolean).join(' ')}
      style={{ maxWidth: 1100, width: 1100 }}
    >
      <div className={['modal-content', contentClassName].filter(Boolean).join(' ')}>
        {children}
      </div>
    </div>
  )
);

const icoBookOpen = solid("book-open");
const icoXmark    = solid("xmark");
const icoLanguage = solid("language");
const icoEarth    = solid("earth-americas");
const icoCity     = solid("city");
const icoShield   = solid("shield");
const icoFrom     = solid("paper-plane");
const icoSort     = solid("sort-alpha-down");
const icoMagnify  = solid("magnifying-glass");
const icoSortUp   = solid("arrow-up-long");
const icoSortDown = solid("arrow-down-long");

class GuideDownload extends Component {
  constructor(props) {
    super(props);
    let mode = this.props.mode;
    let modify_only = this.props.modify_only === "true";
    this.state = {
      visiblePrompt: false,
      category: "",
      add: true,
      defaultCategory: "",
      guides: [],
      guides_unfiltered: [],
      activityIndicator: false,
      guideType: this.props.initial_guide_type || "Mine",
      Countries: [],
      Cities: [],
      Country: "All",
      City: "All",
      Origin: "All",
      // Shared-tab filters ("who shared this with me" / "what access was I
      // granted") and Mine-tab filters ("who I've shared this with" / "what
      // access have I granted") — replace the old 13-option raw-category
      // "Access" multiselect (Mine/"I shared to a few: X"/"I shared to
      // community: X"/"Shared to me: X"/"Shared by community: X") with the
      // simpler, merged pair already shipped in GuideDownloadComponent.js.
      // Found 2026-10-01.
      MyAccessLevel: "All",
      From: "All",
      FromSenders: [],
      SharedOutLevel: "All",
      To: "All",
      ToRecipients: [],
      mode: mode,
      Language: "All",
      // initial_search_text: opens already narrowed (Build My Trip's "From
      // existing guides" opens it for one destination's city). 2026-10-12.
      searchText: this.props.initial_search_text || "",
      modify_only: modify_only,
      AllLanguages: [],

      AlertModalShow: false,
      AlertModalTitle: "",
      AlertModalMessage: "",
      AlertModalButtons: [],
      user_info: { uid: this.props.user_info },

      MultiselectItems: [],
      MultiselectSelectedItems: [],
      MultiselectMode: "uni",
      MultiselectCallback: null,
      MultiselectTitle: "Select",
      MultiselectSearchText: "",
      ShowMultiselect: false,
    };
  }

  _Country = "All";
  _City = "All";
  _Language = "All";
  _guides_cache = {};
  // Shared-tab-only: "my effective access level" (highest of any personal
  // uid:R/C/M + community All_R/C/M grant — see Guide.myAccessLevel) and
  // "who shared this with me" (the guide's owner).
  _MyAccessLevel = "All";
  _From = "All";
  // Mine-tab-only counterparts: "highest access I've granted to anyone
  // else" (Guide.sharedOutLevel) and "who I've shared it with" (a specific
  // recipient uid, not a blanket All_* grant).
  _SharedOutLevel = "All";
  _To = "All";

  LanguageChosen = () => {
    if (this.state.Language.length != this.state.AllLanguages.length) return false;
    return true;
  };

  CountryChosen = () => {
    if (this.state.Country != "All") return true;
    return false;
  };

  CityChosen = () => {
    if (this.state.City != "All") return true;
    return false;
  };

  modalOnShow = () => {
    this._guides_cache = {};
    this.setState({ activityIndicator: true });

    const type = this.state.guideType;
    if (type === "Viewed") {
      const viewed = (this.props.viewed_guides || []).map((v) => ({ id: v.id, data: { ...v.data } }));
      this.setState({ activityIndicator: false, guides_unfiltered: viewed });
      this.processGuideInfo(viewed, null, "Viewed");
      this._fetchType("Mine");
      return;
    }
    this._fetchType(type);
    if (type !== "Featured") this._fetchType("Featured");
  };

  _fetchType = (type) => {
    if (this._guides_cache[type]) {
      if (this.state.guideType === type) {
        this.setState({ activityIndicator: false, guides_unfiltered: this._guides_cache[type] });
        this.processGuideInfo(this._guides_cache[type], null, type);
      }
      return;
    }
    DataBase.getAllGuideInfo(this.props.user_info.uid, (res) => this._handleTypeLoaded(res, type), type);
  };

  _handleTypeLoaded = (res, type) => {
    if (res.pass === false) return;
    const guides = window.guide_obj.classifyAuthorization(res.res, this.props.user_info.uid);
    this._guides_cache[type] = guides;
    // Resolved as soon as each type's data loads (not gated on it being the
    // active tab) — modalOnShow prefetches Featured alongside whichever tab
    // is active, so this keeps the filter options ready the moment the user
    // actually switches to Shared/Mine, same as _guides_cache itself.
    if (type === "Shared") this._resolveFromSenders(guides);
    if (type === "Mine") this._resolveToRecipients(guides);
    if (this.state.guideType === type) {
      this.setState({ activityIndicator: false, guides_unfiltered: guides });
      this.processGuideInfo(guides, null, type);
    }
  };

  // guides_unfiltered must be set on every path that changes what's
  // displayed, not just processGuideInfo's result — onChangeText (the search
  // box) re-filters guides_unfiltered, so leaving it pointing at the previous
  // tab's list (or the initial empty []) made any typed text filter an empty
  // or wrong list and clear the display. Found 2026-09-19: opening on
  // "Viewed" then switching to a cached "Mine" left it at [] (606 guides
  // cached but never assigned).
  switchGuideType = (type) => {
    this.setState({ guideType: type });
    if (type === "Viewed") {
      const viewed = (this.props.viewed_guides || []).map((v) => ({ id: v.id, data: { ...v.data } }));
      this.setState({ guides_unfiltered: viewed });
      this.processGuideInfo(viewed, null, "Viewed");
      return;
    }
    if (this._guides_cache[type]) {
      this.setState({ guides_unfiltered: this._guides_cache[type] });
      this.processGuideInfo(this._guides_cache[type], null, type);
    } else {
      this.setState({ activityIndicator: true });
      this._fetchType(type);
    }
  };

  renderTypeSwitcher = () => {
    const { guideType } = this.state;
    const viewedGuides = this.props.viewed_guides || [];
    const types = [
      ...(viewedGuides.length > 0 ? [{ type: "Viewed", label: "Viewed" }] : []),
      { type: "Mine", label: "My Guides" },
      { type: "Featured", label: "Featured" },
      { type: "Shared", label: "Shared" },
    ];
    return (
      <div className="gd-type-bar">
        {types.map((t) => (
          <button
            key={t.type}
            className={`gd-type-btn${guideType === t.type ? " gd-type-btn--active" : ""}`}
            onClick={() => this.switchGuideType(t.type)}
          >
            {t.label}
          </button>
        ))}
      </div>
    );
  };

  readAllGuideInfoReturn = (res) => {
    this._handleTypeLoaded(res, "Mine");
  };

  processGuideInfo = (guideInfos, searchText, typeOverride) => {
    let guides = [];
    if (searchText == null) searchText = this.state.searchText;
    const guideType = typeOverride !== undefined ? typeOverride : this.state.guideType;
    // Shared shows only accepted guides once the sharing record is loaded;
    // invitations are listed above it (SharedInvitations).
    const acceptedIds =
      guideType === "Shared" && this._sharingState
        ? new Set(splitSharedGuides(guideInfos, this.props.user_info?.uid, this._sharingState).accepted.map((g) => g.id))
        : null;
    // Featured leaves out guides the person hid (reported) or whose owner they blocked.
    const hidden = guideType === "Featured" ? getSharingState() : null;
    const searchTextCap = searchText.toUpperCase();
    for (let g_i = 0; g_i < guideInfos.length; g_i++) {
      let guide_info = guideInfos[g_i];
      if (!Array.isArray(guide_info.data.countries)) guide_info.data.countries = [];
      if (!Array.isArray(guide_info.data.cities)) guide_info.data.cities = [];
      if (!Array.isArray(guide_info.data.categories)) guide_info.data.categories = [];
      // Guides written by mobile (esp. "Mine"'s user_id-merge query — see
      // DataBase.getAllGuideInfo) can be missing these string fields
      // entirely. Unguarded .toUpperCase() below threw a TypeError on any
      // such guide, aborting processGuideInfo before it ever reached the
      // trailing setState — so typing into the search box silently stopped
      // updating the displayed guide list. Matches GuideDownloadComponent.js's
      // identical fix. Found 2026-09-18.
      if (typeof guide_info.data.guide_name !== "string") guide_info.data.guide_name = "";
      if (typeof guide_info.data.description !== "string") guide_info.data.description = "";
      if (typeof guide_info.data.owner_name !== "string") guide_info.data.owner_name = "";
      if (typeof guide_info.data.guide_id !== "string") guide_info.data.guide_id = "";
      if (typeof guide_info.data.user_id !== "string") guide_info.data.user_id = "";
      if (this.state.modify_only === true) {
        let found = false;
        for (let i = 0; i < guide_info.data.categories.length; i++) {
          if (guide_info.data.categories[i].includes("Modify") || guide_info.data.categories[i].includes("Mine")) {
            found = true;
            break;
          }
        }
        if (found === false) continue;
      }
      if (searchTextCap !== "") {
        if (
          !(
            guide_info.data.guide_name.toUpperCase().includes(searchTextCap) ||
            guide_info.data.description.toUpperCase().includes(searchTextCap) ||
            guide_info.data.owner_name.toUpperCase().includes(searchTextCap) ||
            guide_info.data.guide_id.toUpperCase().includes(searchTextCap) ||
            guide_info.data.user_id.toUpperCase().includes(searchTextCap)
          )
        )
          continue;
      }
      if (guide_info.data.language != this._Language && this._Language != "All") continue;
      if (!guide_info.data.countries.includes(this._Country) && this._Country != "All") continue;
      if (!guide_info.data.cities.includes(this._City) && this._City != "All") continue;
      if (acceptedIds && !acceptedIds.has(guide_info.id)) continue;
      if (hidden && hiddenFromLibrary(guide_info, hidden)) continue;
      if (guideType === "Shared") {
        const myLevel = Guide.myAccessLevel(guide_info.data.access, this.props.user_info.uid);
        guide_info.data._myAccessLevel = myLevel;
        if (this._MyAccessLevel !== "All" && myLevel !== this._MyAccessLevel) continue;
        if (this._From !== "All" && guide_info.data.user_id !== this._From) continue;
      }
      if (guideType === "Mine") {
        const sharedLevel = Guide.sharedOutLevel(guide_info.data.access, this.props.user_info.uid);
        guide_info.data._sharedOutLevel = sharedLevel;
        if (this._SharedOutLevel !== "All") {
          const wantNotShared = this._SharedOutLevel === "Not shared";
          if (wantNotShared && sharedLevel !== null) continue;
          if (!wantNotShared && sharedLevel !== this._SharedOutLevel) continue;
        }
        if (this._To !== "All" && !Guide.sharedOutRecipients(guide_info.data.access, this.props.user_info.uid).includes(this._To))
          continue;
      }
      if (guideType !== "Featured" && guideType !== "Viewed" && guide_info.data.type === "Featured") continue;
      guides.push(guide_info);
    }
    // _sort_ascending is 1 (normal direction) or -1 (reversed) — toggleSortDirection
    // flips this and re-runs the sort, without needing a second copy of each comparator.
    const _dir = this._sort_ascending === false ? -1 : 1;
    if (this._sort_option === "Name")
      guides = guides.sort((a, b) => ((a.data.guide_name || "").toUpperCase() > (b.data.guide_name || "").toUpperCase() ? 1 : -1) * _dir);
    else if (this._sort_option === "Rating") guides = guides.sort((a, b) => (a.data.rating < b.data.rating ? 1 : -1) * _dir);
    else if (this._sort_option === "Times Reviewed")
      guides = guides.sort((a, b) => (a.data.num_ratings < b.data.num_ratings ? 1 : -1) * _dir);
    else if (this._sort_option === "Times Read")
      guides = guides.sort((a, b) => (a.data.times_read < b.data.times_read ? 1 : -1) * _dir);
    else if (this._sort_option === "Times Copied")
      guides = guides.sort((a, b) => (a.data.times_copied < b.data.times_copied ? 1 : -1) * _dir);
    else if (this._sort_option === "Read date") guides = guides.sort((a, b) => (a.data.read < b.data.read ? 1 : -1) * _dir);
    else if (this._sort_option === "Modified date") guides = guides.sort((a, b) => (a.data.mod < b.data.mod ? 1 : -1) * _dir);
    else if (this._sort_option === "Created date")
      guides = guides.sort((a, b) => (a.data.created < b.data.created ? 1 : -1) * _dir);
    else if (this._sort_option === "Country")
      guides = guides.sort((a, b) =>
        (((a.data.countries || [])[0] || "").toUpperCase() > ((b.data.countries || [])[0] || "").toUpperCase() ? 1 : -1) * _dir
      );
    else if (this._sort_option === "City")
      guides = guides.sort((a, b) =>
        (((a.data.cities || [])[0] || "").toUpperCase() > ((b.data.cities || [])[0] || "").toUpperCase() ? 1 : -1) * _dir
      );
    let _countries = [];
    let _cities = [];
    let _languages = [];
    guides.forEach((guide_info) => {
      if (typeof guide_info.data.language != "undefined")
        if (!_languages.includes(guide_info.data.language)) _languages.push(guide_info.data.language);
      if (typeof guide_info.data.countries != "undefined") _countries = _countries.concat(guide_info.data.countries);
      if (typeof guide_info.data.cities != "undefined") _cities = _cities.concat(guide_info.data.cities);
    });
    _languages = _languages.sort();
    var languages_set = new Set(_languages);
    _languages = [...languages_set].sort();
    _languages.unshift("All");
    let languages = [];
    _languages.forEach((language) => {
      languages.push({
        label: language,
        name: language,
        value: language,
      });
    });
    var countries_set = new Set(_countries);
    _countries = [...countries_set].sort();
    _countries.unshift("All");
    let countries = [];
    _countries.forEach((country) => {
      countries.push({
        label: country,
        name: country,
        value: country,
      });
    });
    var cities_set = new Set(_cities);
    _cities = [...cities_set].sort();
    _cities.unshift("All");
    let cities = [];
    _cities.forEach((city) => {
      cities.push({
        label: city,
        name: city,
        value: city,
      });
    });
    this.setState({
      guides: guides,
      Languages: languages,
      AllLanguages: languages,
      Countries: countries,
      Cities: cities,
    });
  };

  onChangeText = (event) => {
    this.setState({ searchText: event.target.value });
    this.processGuideInfo(this.state.guides_unfiltered, event.target.value);
  };

  cancelTextSearch = () => {
    this.setState({ searchText: "" });
    this.processGuideInfo(this.state.guides_unfiltered, "");
  };

  _attributes = null;
  _guide_id = null;

  selectedGuide = (res) => {
    console.log(res);
  };

  selectGuide = (item) => {
    if (item == null) {
      this.props.onHide();
      return;
    }
    let callback = this.props.callback;
    if (callback != null)
      callback({ guide_info_id: item.id, guide_id: item.data.guide_id, guide_name: item.data.guide_name });
    this.props.onHide();
    return;
  };

  readGuideDataReturn = (res) => {
    console.log("readGuideDataReturn", res.guide_id);
  };

  updateUserCallback = (res) => {
    console.log("updateUserCallback", res.pass);
  };

  // Share invitations (4.10.55): the person's private sharing record —
  // undefined while loading, null when it can't be used (then every shared
  // guide shows, as before), else { accepted, hidden, blocked }.
  _sharingState = undefined;

  onSharingState = (st) => {
    this._sharingState = st;
    if (this.state.guideType === "Shared" && this._guides_cache.Shared) this.processGuideInfo(this._guides_cache.Shared, null, "Shared");
  };

  // A guide hidden elsewhere (Report this Guide) leaves the lists at once (2026-10-29).
  componentDidMount() {
    this._unsubSharing = onSharingChanged((st) => {
      if (!st || st === this._sharingState) return;
      if (this._sharingState) this.onSharingState(st);
      if (this.state.guideType === "Featured" && this._guides_cache.Featured) this.processGuideInfo(this._guides_cache.Featured, null, "Featured");
    });
  }

  componentWillUnmount() {
    this._unsubSharing?.();
  }

  // Hides a guide someone shared with you; it isn't deleted for its owner.
  removeSharedGuide = (guide_info_id, name) => {
    this.MyAlert("Confirmation", `Remove "${name}" from your Library? It stays with its owner — you just won't see it any more.`, [
      {
        Title: "Remove",
        Method: () => {
          const uid = this.props.user_info?.uid;
          DataBase.sharingAction(uid, "hide", guide_info_id);
          const next = applySharingAction(this._sharingState, "hide", guide_info_id);
          this.onSharingState(next);
          notifySharingChanged(next);
        },
      },
      { Title: "Cancel", Method: null },
    ]);
  };

  MyAlert = (title, message, buttons) => {
    this.setState({
      AlertModalTitle: title,
      AlertModalMessage: message,
      AlertModalButtons: buttons,
      AlertModalShow: true,
    });
  };

  deleteGuide = (guide_info_id, guide_id) => {
    const uid = this.props.user_info?.uid;
    if (!uid || uid === "guest") {
      this.MyAlert("Message", "Guides cannot be deleted in guest mode", [{ Title: "OK", Method: () => null }]);
      return;
    }
    if (guide_id === this.props.guide_meta.guide_id) {
      this.setState({ activityIndicator: false });
      this.MyAlert("Message", "Cannot delete guide that you are viewing", [{ Title: "OK", Method: () => null }]);
      return;
    }
    this.MyAlert("Confirmation", "Confirm Delete guide from cloud?", [
      { Title: "OK", Method: () => this.onDeleteOnlineGuide(guide_info_id, guide_id) },
      { Title: "CANCEL", Method: null },
    ]);
  };

  // The real "choose Schedule vs Places, then merge" flow lives in App.js
  // (handleChooseCopyMode) — this dialog is rendered from several files
  // (HomeHeader.js, MobileBottomNavBar.js, MobileHeader.js,
  // HTMLLinksModalClass.js) that don't have direct access to it, so this
  // dispatches a custom event App.js listens for instead, same pattern as
  // openLoginModal elsewhere in this app. Only guide_info_id is actually
  // read on the other end (handleChooseCopyMode's single param) — the
  // second arg GuideCard.js's CopyFromGuide passes (guide_id) isn't needed
  // here. Found 2026-09-24.
  CopyFromGuide = (guide_info_id) => {
    window.dispatchEvent(new CustomEvent("openCopyGuideMode", { detail: { guide_info_id } }));
  };

  _deleteGuideID = "";
  onDeleteOnlineGuide = (guide_info_id, guide_id) => {
    this._deleteGuideID = guide_id;
    DataBase.deleteGuideInfo(guide_info_id, this.deleteGuideInfoCallback);
  };

  deleteGuideInfoCallback = (res) => {
    if (res.pass === true) {
      DataBase.deleteGuideData(this._deleteGuideID, this.deleteGuideDataCallback);
    }
  };

  deleteGuideDataCallback = () => {
    this._deleteGuideID = null;
    DataBase.getAllGuideInfo(this.props.user_info.uid, this.readAllGuideInfoReturn, this.props.guide_download_category);
  };

  guideDetails = (item) => {
    console.log("guideDetails", item);
  };

  showCountries = (item) => {
    const guideAttributes = item.data;
    let countries = "";
    if (typeof guideAttributes["countries"] != "undefined") countries = guideAttributes["countries"].join(", ");
    return countries;
  };

  showCities = (item) => {
    const guideAttributes = item.data;
    let cities = "";
    if (typeof guideAttributes["cities"] != "undefined") cities = guideAttributes["cities"].join(", ");
    return cities;
  };

  selectLanguage = () => {
    this.MultiSelect(this.state.Languages, [this._Language], "uni", this.selectedLanguage, "Language");
  };

  selectedLanguage = (language) => {
    if (language.length < 1) {
      this.setState({ Language: "All" });
      this._Language = "All";
    } else {
      this.setState({ Language: language[0].label });
      this._Language = language[0].label;
    }
    this.processGuideInfo(this.state.guides_unfiltered);
  };

  selectCountry = () => {
    this.MultiSelect(this.state.Countries, [this._Country], "uni", this.selectedCountry, "Country");
  };

  selectedCountry = (country) => {
    if (country.length < 1) {
      this.setState({ Country: "All" });
      this._Country = "All";
    } else {
      this.setState({ Country: country[0].label });
      this._Country = country[0].label;
    }
    this.processGuideInfo(this.state.guides_unfiltered);
  };

  selectCity = () => {
    this.MultiSelect(this.state.Cities, [this._City], "uni", this.selectedCity, "City or Place");
  };

  selectedCity = (city) => {
    if (city.length < 1) {
      this.setState({ City: "All" });
      this._City = "All";
    } else {
      this.setState({ City: city[0].label });
      this._City = city[0].label;
    }
    this.processGuideInfo(this.state.guides_unfiltered);
  };

  _sort_option = this.props.guide_sort_option;
  sortBy = () => {
    const sort_options = [
      "Name",
      "Rating",
      "Times Reviewed",
      "Times Read",
      "Read date",
      "Modified date",
      "Created date",
      "Country",
      "City",
    ];
    let sort_options_list = [];
    sort_options.forEach((option) => {
      sort_options_list.push({
        label: option,
        value: option,
      });
    });
    const _selectedItems = [{ label: this._sort_option, value: this._sort_option }];
    this.MultiSelect(sort_options_list, _selectedItems, "uni", this.selectedSortOption, "Sort Option");
  };

  selectedSortOption = (sort_option) => {
    if (sort_option.length > 0) this._sort_option = sort_option[0].label;
    this.props.set_guide_sort_option(this._sort_option);
    this.processGuideInfo(this.state.guides_unfiltered);
  };

  _sort_ascending = true;
  toggleSortDirection = () => {
    this._sort_ascending = !this._sort_ascending;
    // processGuideInfo calls setState internally, which re-renders (including
    // this button's icon) — no separate forceUpdate needed.
    this.processGuideInfo(this.state.guides_unfiltered);
  };

  // Builds the "From" filter's option list — one entry per distinct guide
  // owner across the current Shared results, resolved via the existing
  // one-uid-at-a-time User.findUserByUID (no batching helper exists anywhere
  // in the app; the number of distinct senders in a "shared with me" list is
  // small enough that this is cheap). Falls back to email when a sender
  // never set a name, same convention as UsersDialog.js. Matches
  // GuideDownloadComponent.js's identical addition.
  _resolveFromSenders = (guides) => {
    const distinctUids = [...new Set(guides.map((g) => g.data.user_id).filter(Boolean))];
    if (distinctUids.length === 0) {
      this.setState({ FromSenders: [] });
      return;
    }
    let pending = distinctUids.length;
    const senders = [];
    distinctUids.forEach((uid) => {
      User.findUserByUID(uid, (res) => {
        const fullName = res?.pass === true ? `${res.res.first_name || ""} ${res.res.last_name || ""}`.trim() : "";
        const label = fullName || (res?.pass === true ? res.res.email : "") || uid;
        senders.push({ label, value: uid, name: uid });
        pending -= 1;
        if (pending === 0) {
          senders.sort((a, b) => (a.label.toUpperCase() > b.label.toUpperCase() ? 1 : -1));
          this.setState({ FromSenders: senders });
        }
      });
    });
  };

  selectMyAccessLevel = () => {
    // "All" is a real, selectable option so this single-select filter can be
    // cleared from inside the dialog itself, without a separate "clear" UI.
    const options = ["All", "Read", "Copy", "Modify"].map((level) => ({ label: level, name: level, value: level }));
    this.MultiSelect(options, [this._MyAccessLevel], "uni", this.selectedMyAccessLevel, "To me");
  };

  selectedMyAccessLevel = (selected) => {
    const level = selected.length < 1 ? "All" : selected[0].label;
    this.setState({ MyAccessLevel: level });
    this._MyAccessLevel = level;
    this.processGuideInfo(this.state.guides_unfiltered);
  };

  selectFrom = () => {
    const options = [{ label: "All", value: "All", name: "All" }, ...this.state.FromSenders];
    // Preselect the actual matching object (value=uid), not just the stored
    // label — two different senders can resolve to the same display label
    // (e.g. a shared name or the same email-fallback), and matching by label
    // alone would risk pre-checking the wrong person.
    const currentlySelected = options.find((r) => r.value === this._From) || options[0];
    this.MultiSelect(options, [currentlySelected], "uni", this.selectedFrom, "From");
  };

  selectedFrom = (selected) => {
    const uid = selected.length < 1 ? "All" : selected[0].value;
    const label = selected.length < 1 ? "All" : selected[0].label;
    this.setState({ From: label });
    this._From = uid;
    this.processGuideInfo(this.state.guides_unfiltered);
  };

  // Mine-tab counterpart to _resolveFromSenders — one entry per distinct
  // recipient (individually-named uid:R/C/M grants, not blanket All_*)
  // across all of the current user's own guides.
  _resolveToRecipients = (guides) => {
    const distinctUids = [
      ...new Set(
        guides.flatMap((g) => Guide.sharedOutRecipients(g.data.access, this.props.user_info.uid))
      ),
    ];
    if (distinctUids.length === 0) {
      this.setState({ ToRecipients: [] });
      return;
    }
    let pending = distinctUids.length;
    const recipients = [];
    distinctUids.forEach((uid) => {
      User.findUserByUID(uid, (res) => {
        const fullName = res?.pass === true ? `${res.res.first_name || ""} ${res.res.last_name || ""}`.trim() : "";
        const label = fullName || (res?.pass === true ? res.res.email : "") || uid;
        recipients.push({ label, value: uid, name: uid });
        pending -= 1;
        if (pending === 0) {
          recipients.sort((a, b) => (a.label.toUpperCase() > b.label.toUpperCase() ? 1 : -1));
          this.setState({ ToRecipients: recipients });
        }
      });
    });
  };

  selectSharedOutLevel = () => {
    const options = ["All", "Not shared", "Read", "Copy", "Modify"].map((level) => ({ label: level, name: level, value: level }));
    this.MultiSelect(options, [this._SharedOutLevel], "uni", this.selectedSharedOutLevel, "Shared");
  };

  selectedSharedOutLevel = (selected) => {
    const level = selected.length < 1 ? "All" : selected[0].label;
    this.setState({ SharedOutLevel: level });
    this._SharedOutLevel = level;
    this.processGuideInfo(this.state.guides_unfiltered);
  };

  selectTo = () => {
    const options = [{ label: "All", value: "All", name: "All" }, ...this.state.ToRecipients];
    const currentlySelected = options.find((r) => r.value === this._To) || options[0];
    this.MultiSelect(options, [currentlySelected], "uni", this.selectedTo, "To");
  };

  selectedTo = (selected) => {
    const uid = selected.length < 1 ? "All" : selected[0].value;
    const label = selected.length < 1 ? "All" : selected[0].label;
    this.setState({ To: label });
    this._To = uid;
    this.processGuideInfo(this.state.guides_unfiltered);
  };

  MultiSelect = (Items, SelectedItems, Mode, Callback, Title) => {
    this.setState({
      MultiselectItems: Items,
      MultiselectSelectedItems: SelectedItems,
      MultiselectMode: Mode,
      MultiselectCallback: Callback,
      MultiselectTitle: Title,
      MultiselectSearchText: "",
      ShowMultiselect: true,
    });
  };

  handleSearchChanged = () => {};

  render() {
    return (
      <div className="modal" style={{ zIndex: 65537 }}>
        <Modal
          show={this.props.show}
          animation={false}
          dialogClassName="gd-dialog"
          dialogAs={GdDialogWrapper}
          aria-labelledby="gd-title"
          centered={false}
          scrollable={false}
          onShow={this.modalOnShow}
          onHide={this.props.onHide}
        >
          <Modal.Body style={{ padding: 0 }}>
            <div className="gd-shell">

              {/* ── Header ── */}
              <div className="gd-header">
                <div className="gd-header-icon">
                  <FontAwesomeIcon icon={icoBookOpen} />
                </div>
                <h2 className="gd-title" id="gd-title">Search Guides</h2>
                <button className="gd-close" onClick={this.props.onHide}>
                  <FontAwesomeIcon icon={icoXmark} />
                </button>
              </div>

              {/* ── Type switcher ── */}
              {!this.state.modify_only && this.renderTypeSwitcher()}

              {/* ── Filters ── */}
              <div className="gd-filters">
                <button
                  className={`gd-filter-btn${this.state.Language !== "All" ? " gd-filter-btn--active" : ""}`}
                  onClick={this.selectLanguage}
                  title="Filter by Language"
                >
                  <FontAwesomeIcon icon={icoLanguage} />
                  <span>Language</span>
                </button>
                <button
                  className={`gd-filter-btn${this.state.Country !== "All" ? " gd-filter-btn--active" : ""}`}
                  onClick={this.selectCountry}
                  title="Filter by Country"
                >
                  <FontAwesomeIcon icon={icoEarth} />
                  <span>Country</span>
                </button>
                <button
                  className={`gd-filter-btn${this.state.City !== "All" ? " gd-filter-btn--active" : ""}`}
                  onClick={this.selectCity}
                  title="Filter by City"
                >
                  <FontAwesomeIcon icon={icoCity} />
                  <span>City</span>
                </button>
                {this.state.guideType === "Shared" && (
                  <>
                    <button
                      className={`gd-filter-btn${this.state.MyAccessLevel !== "All" ? " gd-filter-btn--active" : ""}`}
                      onClick={this.selectMyAccessLevel}
                      title="Filter by what access you were granted"
                    >
                      <FontAwesomeIcon icon={icoShield} />
                      <span>{this.state.MyAccessLevel === "All" ? "To me" : `To me: ${this.state.MyAccessLevel}`}</span>
                    </button>
                    <button
                      className={`gd-filter-btn${this.state.From !== "All" ? " gd-filter-btn--active" : ""}`}
                      onClick={this.selectFrom}
                      title="Filter by who shared it with you"
                    >
                      <FontAwesomeIcon icon={icoFrom} />
                      <span>{this.state.From === "All" ? "From" : `From: ${this.state.From}`}</span>
                    </button>
                  </>
                )}
                {this.state.guideType === "Mine" && (
                  <>
                    <button
                      className={`gd-filter-btn${this.state.SharedOutLevel !== "All" ? " gd-filter-btn--active" : ""}`}
                      onClick={this.selectSharedOutLevel}
                      title="Filter by the access you've granted others"
                    >
                      <FontAwesomeIcon icon={icoShield} />
                      <span>{this.state.SharedOutLevel === "All" ? "Shared" : `Shared: ${this.state.SharedOutLevel}`}</span>
                    </button>
                    <button
                      className={`gd-filter-btn${this.state.To !== "All" ? " gd-filter-btn--active" : ""}`}
                      onClick={this.selectTo}
                      title="Filter by who you've shared it with"
                    >
                      <FontAwesomeIcon icon={icoFrom} />
                      <span>{this.state.To === "All" ? "To" : `To: ${this.state.To}`}</span>
                    </button>
                  </>
                )}
                <button
                  className="gd-filter-btn"
                  onClick={this.sortBy}
                  title="Sort guides"
                >
                  <FontAwesomeIcon icon={icoSort} />
                  <span>Sort</span>
                </button>
                <button
                  className="gd-filter-btn"
                  onClick={this.toggleSortDirection}
                  title={this._sort_ascending ? "Reverse sort order" : "Restore sort order"}
                >
                  <FontAwesomeIcon icon={this._sort_ascending ? icoSortUp : icoSortDown} />
                </button>
              </div>

              {/* ── Search ── */}
              <div className="gd-search-row">
                <div className="gd-search-wrap">
                  <FontAwesomeIcon icon={icoMagnify} className="gd-search-icon" />
                  <input
                    className="gd-search"
                    type="text"
                    placeholder="Search guides…"
                    value={this.state.searchText}
                    onChange={this.onChangeText}
                  />
                  {this.state.searchText && (
                    <button className="gd-search-clear" onClick={this.cancelTextSearch}>
                      <FontAwesomeIcon icon={icoXmark} />
                    </button>
                  )}
                </div>
                <span className="gd-count">{this.state.guides.length} guides</span>
              </div>
              {this.state.guideType === "Featured" && (
                <p className="gd-ai-disclaimer" data-testid="featured-ai-disclaimer">
                  {AI_DISCLAIMER}{" "}
                  <a href={FEEDBACK_URL}>
                    {AI_DISCLAIMER_LINK_TEXT}
                  </a>
                </p>
              )}

              {/* ── Body ── */}
              <div className="gd-body">
                {this.state.activityIndicator && (
                  <div className="gd-loading">
                    <div className="gd-spinner" />
                  </div>
                )}
                {this.state.guideType === "Shared" && this._guides_cache.Shared && (
                  <SharedInvitations
                    uid={this.props.user_info?.uid}
                    guides={this._guides_cache.Shared}
                    onStateChange={this.onSharingState}
                    onOpen={(g) => {
                      this.props.callback(g.id, g.data.guide_id, g.data.guide_name);
                      this.props.onHide();
                    }}
                    confirm={(message, onYes) =>
                      this.MyAlert("Confirmation", message, [
                        { Title: "Block", Method: onYes },
                        { Title: "Cancel", Method: null },
                      ])
                    }
                  />
                )}
                {this.state.guides.map((guide, index) => (
                  <GuideCard
                    key={index}
                    name={guide.data.guide_name}
                    rating={guide.data.rating}
                    reviews={guide.data.num_ratings}
                    read={guide.data.times_read}
                    language={guide.data.language}
                    countries={guide.data.countries}
                    cities={guide.data.cities}
                    access={guide.data.access_summary}
                    image={guide.data.image}
                    image_m={guide.data.image_m}
                    id={guide.id}
                    callback={this.props.callback}
                    delete_callback={this.deleteGuide}
                    copy_callback={this.CopyFromGuide}
                    remove_callback={this.state.guideType === "Shared" && this._sharingState ? this.removeSharedGuide : null}
                    info_callback={this.guideDetails}
                    onHide={this.props.onHide}
                    guide_info={guide.data}
                    guide_info_id={guide.id}
                    mode={this.props.mode}
                  />
                ))}
              </div>

            </div>
          </Modal.Body>
        </Modal>

        {this.state.AlertModalShow && (
          <AlertModal
            show={this.state.AlertModalShow}
            onHide={() => this.setState({ AlertModalShow: false })}
            AlertModalTitle={this.state.AlertModalTitle}
            AlertModalMessage={this.state.AlertModalMessage}
            AlertModalButtons={this.state.AlertModalButtons}
          />
        )}

        {this.state.ShowMultiselect && (
          <MultiSelectModal
            show={this.state.ShowMultiselect}
            onHide={() => this.setState({ ShowMultiselect: false })}
            MultiselectItems={this.state.MultiselectItems}
            MultiselectSelectedItems={this.state.MultiselectSelectedItems}
            MultiselectMode={this.state.MultiselectMode}
            MultiselectCallback={this.state.MultiselectCallback}
            MultiselectTitle={this.state.MultiselectTitle}
            MultiselectSearchText={this.state.MultiselectSearchText}
          />
        )}
      </div>
    );
  }
}

export default GuideDownload;
